/**
 * IMPORT
 */
import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {ExcRestService} from 'exc-rest';
import {ExcSigninService} from "exc-signin";
import {MessageService} from 'primeng/api';

/**
 * COMPONENT
 */
@Component({
  selector: 'app-sequence-step',
  templateUrl: './sequence-step.component.html',
  styles: []
})
/**
 * Klasse für die Initialisierung der Steps einer Sequenzen eines Selfchecks. <br>
 * @version Angular 7.0.0 <br>
 * @since 15.11.2022 <br>
 * xx.xx.xxxx wg. Evaluierung <br>
 * 15.11.2022 wg. Dokumentation <br>
 * @author Denny M. Lüdicke <br> E-Mail: denny.luedicke@excon.com <br>
 * Veränderungen von Denny M. Lüdicke
 */
export class SequenceStepComponent extends ExcTranslation implements OnInit
{

      /**
       * VIEW
       */
      @ViewChild('menuPopup') menuPopup;

      /**
       * INPUT
       */
      @Input('sequenceWorkspace') sequenceWorkspace : any;
      @Input('sequenceStep')
      set sequenceStep(value: any)
      {
          this._sequenceStep = value;
          if(value)
          {
            this.sequenceStepClone = this.clone(value);
          }
          else{
            this.sequenceStepClone = undefined;
          }
      }
      get sequenceStep(): any
      {
          return this._sequenceStep;
      }
      private _sequenceStep : any;
      @Input('enumeration')
      set enumeration(value)
      {
        this._enumeration = value;
        if(value)
        {
          this.selectedTyp = this._enumeration.Steps.find((step) => step.stID == this.sequenceStepClone.stID);
        }

      }
      get enumeration()
      {
          return this._enumeration;
      }
      private _enumeration;
      @Input('switchMode') switchMode;
      @Input('ssOrderLength') ssOrderLength;

      /**
       * ATTRIBUTE
       */
      isSequenceStepVisible = false;
      editMode = false;
      sequenceStepClone: any;
      typselection: number | undefined;
      private selectedTyp: any;
      sequenceIsLoading = false;
      changedStep =
      {
          ss_stID: 0,
          ssOrder: 0,
          ssCaption: '',
          ssTip: '',
          ssInternalRemark: null,
          ssImagesMin: 0 ,
          ssImagesMax: 0 ,
          ssSkipTo: null
      };
      textFps =
      [
          this.getRessource('TextVinRecognition'),
          this.getRessource('TextVinDetectionFailed'),
          this.getRessource('TextPictureVehicleInTheLongShot'),
          this.getRessource('TextSummary')
      ];
      textCommit =
      [
          this.getRessource('QuestionText'),
          this.getRessource('PositiveAnswer'),
          this.getRessource('NegativeAnswer')
      ];
      newDescription =
      {
          descriptionOne: '',
          descriptionTwo: '',
          descriptionThree: '',
          descriptionFour: '',
      }
      newCommit =
      {
          questionCommit: '',
          positiveCommit: '',
          negativeCommit: '',
      }


      /**
       * METHODEN
       */
      /**
       * @param constructor( ExcSigninService, ExcSigninService, MessageService )
       */
      constructor( private excrest: ExcRestService, private excSec: ExcSigninService, private messageService: MessageService )
      {
          super();
      }
      /**
       * @param ngOnInit()
       */
      ngOnInit()
      {

      }
      /** Die Zusammenfassung der Beschreibungen für stID 12 und 18 */
      getFpsDescription() : string
      {
          let discriptionCange = [];
          discriptionCange = [this.newDescription.descriptionOne, this.newDescription.descriptionTwo, this.newDescription.descriptionThree, this.newDescription.descriptionFour];

          let discriptionOriginal = [];
          for (let index = 0 ; index < this.sequenceStepClone.ssTip.split(';').length; index++)
          {
            discriptionOriginal[index] = this.sequenceStepClone.ssTip.split(';')[index];
          }
          for (let index = 0 ; index < discriptionCange.length; index++)
          {
            if (discriptionCange[index] !== '')
            {
              // console.log(discriptionCange[index]);
              discriptionOriginal[index] = discriptionCange[index];
            }
          }
          let descriptionMerge = '';
          descriptionMerge = discriptionOriginal[0]+';'+discriptionOriginal[1]+';'+discriptionOriginal[2]+';'+discriptionOriginal[3];
          descriptionMerge;

          // console.log(descriptionMerge);
          return descriptionMerge;
      };
      getCommitDescription() : string
      {
        let commitChange = [];
        commitChange = [this.newCommit.questionCommit, this.newCommit.positiveCommit, this.newCommit.negativeCommit];

        let commitOriginal = [];
        for (let index = 0 ; index < this.sequenceStepClone.ssTip.split(';').length; index++)
        {
          commitOriginal[index] = this.sequenceStepClone.ssTip.split(';')[index];
        }
        for (let index = 0 ; index < commitChange.length; index++)
        {
          if (commitChange[index] !== '')
          {
            commitOriginal[index] = commitChange[index];
          }
        }

        let commitMerge = '';
        commitMerge = commitOriginal[0] + ';' + commitOriginal[1] + ';' + commitOriginal[2];

        // console.log(commitMerge);
        return commitMerge;
      };
      /**
       * @param changeEditMode()
       */
      changeEditMode()
      {
          if(this.editMode === false)
          {
              this.editMode = true;
          }
          else
          {
              this.editMode = false;
          }
          // Kontrolle Editvalue
          // console.log(this.editMode);
      }
      /**
       * @param isAbort()
       */
      isAbort()
      {
          this.editMode = false;
      }
    /**
     * @param isSequencesChanged
     */
      isSequencesChanged = (): boolean =>
      {
          // console.log(this.changed( this.selfcheckConfigData.Workspace.sequences, this.selfcheckConfigData.Workspace.sequencesClone ));
          return this.changed( this._sequenceStep, this.sequenceStepClone );
      }
      /**
       * @param clone( any )
       */
      clone(cloneObj: any): any
      {
          return JSON.parse(JSON.stringify(cloneObj));
      }
      /**
       * @param changed( any, any)
       */
      changed(objBefore: any, objAfter: any): boolean
      {
          return JSON.stringify(objBefore) !== JSON.stringify(objAfter);
      }
      /**
       * @param tipInputChange( any, any )
       */
      tipInputChange(newTipValue: any, oldTipValue: any, indexStep: any)
      {
          if( indexStep === 3)
          {
            this.newDescription.descriptionOne = newTipValue;
          }
          if( indexStep === 4)
          {
            this.newDescription.descriptionTwo = newTipValue;
          }
          if( indexStep === 5)
          {
            this.newDescription.descriptionThree = newTipValue;
          }
          if( indexStep === 6)
          {
            this.newDescription.descriptionFour = newTipValue;
          }
          if( indexStep === 7)
          {
            //console.log('i = ' +  indexStep);
            this.newCommit.questionCommit = newTipValue;
          }
          if( indexStep === 8)
          {
            this.newCommit.positiveCommit = newTipValue;
          }
          if( indexStep === 9)
          {
            this.newCommit.negativeCommit = newTipValue;
          }
      }
      /**
       * @param showSuccess()
       */
      showSuccess()
      {
          this.messageService.add({severity:'success', summary: 'Erfolgreich', detail: 'Speichern erfolgreich!'});
      }
      /**
       * @param selectedTypeChanged( event )
       */
      selectedTypeChanged(event)
      {
          this.sequenceStepClone.stID = event;
          this.selectedTyp = this._enumeration.Steps.find((step) => step.stID == event);
      }
      /**
       * @param getStepTypCaption( any )
       */
      getStepTypCaption(stID: any)
      {
          return this.getRessource('StId_' + stID + '_Caption');
      }
      /**
       * @param saveChangedStep()
       */
      saveChangedStep()
      {
        // if( this.sequenceStepClone !== '' )
        // {
        //   this.completeDescription();
        // }
        if( !(this.sequenceStepClone.stID == 12 || this.sequenceStepClone.stID == 14 || this.sequenceStepClone.stID == 18) ) {
          this.changedStep =
            {
              ss_stID: this.sequenceStepClone.stID,
              ssOrder: this.sequenceStepClone.ssOrder,
              ssCaption: this.sequenceStepClone.ssCaption,
              ssTip: this.sequenceStepClone.ssTip,
              ssInternalRemark: this.sequenceStepClone.ssInternalRemark,
              ssImagesMin: Number(this.sequenceStepClone.ssImagesMin),
              ssImagesMax: Number(this.sequenceStepClone.ssImagesMax),
              ssSkipTo: this.sequenceStepClone.ssSkipTo
            };
        }
        if( this.sequenceStepClone.stID == 12 || this.sequenceStepClone.stID == 18 ) {
          this.changedStep =
            {
              ss_stID: this.sequenceStepClone.stID,
              ssOrder: this.sequenceStepClone.ssOrder,
              ssCaption: this.sequenceStepClone.ssCaption,
              ssTip: this.getFpsDescription(),
              ssInternalRemark: this.sequenceStepClone.ssInternalRemark,
              ssImagesMin: Number(this.sequenceStepClone.ssImagesMin),
              ssImagesMax: Number(this.sequenceStepClone.ssImagesMax),
              ssSkipTo: this.sequenceStepClone.ssSkipTo
            };
        }
        if( this.sequenceStepClone.stID == 14 ) {
          this.changedStep =
            {
              ss_stID: this.sequenceStepClone.stID,
              ssOrder: this.sequenceStepClone.ssOrder,
              ssCaption: this.sequenceStepClone.ssCaption,
              ssTip: this.getCommitDescription(),
              ssInternalRemark: this.sequenceStepClone.ssInternalRemark,
              ssImagesMin: Number(this.sequenceStepClone.ssImagesMin),
              ssImagesMax: Number(this.sequenceStepClone.ssImagesMax),
              ssSkipTo: this.sequenceStepClone.ssSkipTo
            };
        }
          this.changeStep();
          this.isAbort();
      }
      /**
       * @param changeStep()
       */
      changeStep()
      {
          let ssID = this.sequenceStepClone.ssID;
          let step = this.changedStep;

          this.sequenceIsLoading = true;
          this.excrest.post(this.excrest.computeUrl
            (
              'SelfcheckConfig_Step_Post', {ssID}
            ),
            step, {}
          ).subscribe
          ( response =>
          {
              // console.log(response);
              // if( response.success && response.data.length >= 0 )
              // {
              //     let changeStep = response.data[0];
              //     Object.assign(changeStep, {ssID: changeStep.ssID})
              //
              //     console.log(response.data[0]);
              //     this.sequenceWorkspace.Steps.push(response.data[0]);
              // }
              this.sequenceIsLoading = false;
          });
      }

      // testSave(){
      //   this.getFpsDescription();
      //   this.getCommitDescription();
      //   console.log('testSave()');
      // }
}
